import React from "react";

interface PaymentOptionProps {
  headline: string;
  logoSrc: string; // Logo für die Zahlungsart
  children: React.ReactNode; // Individuelle Inhalte für jede Option
  isSelected?: boolean; // Ist die Option ausgewählt?
  onClick?: () => void; // Klick-Handler für die Auswahl
}

const PaymentOption: React.FC<PaymentOptionProps> = ({
  headline,
  logoSrc,
  children,
  isSelected = false,
  onClick,
}) => {
  const containerStyle: React.CSSProperties = {
    position: "relative",
    padding: "20px 15px",
    border: "1px solid #d3d7da",
    borderRadius: "8px",
    backgroundColor: isSelected ? "#fff9f0" : "#f6f4f2", // Hervorhebung bei Auswahl
    fontFamily: "Avenir Next Codensed Regular",
    color: "rgb(52, 39, 20)",
    boxShadow: isSelected
      ? "0 4px 12px rgba(0, 0, 0, 0.2)" // Stärkere Schatten bei Auswahl
      : "0 4px 6px rgba(0, 0, 0, 0.1)", // Normaler Schatten
    marginBottom: "20px",
    overflow: "hidden",
    borderWidth: isSelected ? "1px 1px 4px 1px" : "1px", // Untere Border verstärken
    borderColor: isSelected ? "#000" : "#d3d7da",
    cursor: "pointer", // Zeigt, dass die Option klickbar ist
    transition: "all 0.3s ease", // Animation für flüssige Übergänge
  };

  const headlineStyle: React.CSSProperties = {
    fontSize: "1.5rem",
    fontWeight: 600,
    marginBottom: "10px",
    color: "#514633",
  };

  const logoStyle: React.CSSProperties = {
    position: "absolute",
    top: "15px",
    right: "15px",
    width: "40px",
    height: "40px",
    objectFit: "contain",
  };

  const contentStyle: React.CSSProperties = {
    marginTop: "20px",
  };

  return (
    <div style={containerStyle} onClick={onClick}>
      {/* Headline und Logo */}
      <div>
        <h3 style={headlineStyle}>{headline}</h3>
        <img src={logoSrc} alt={headline} style={logoStyle} />
      </div>

      {/* Individueller Inhalt */}
      <div style={contentStyle}>{children}</div>
    </div>
  );
};

export default PaymentOption;
